// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header":"_2P8D-0 aLs3Nr","toptitle":"_1IVRt6","title":"_25C0oS","subtitle":"_2aAA1W","bannerLink":"_1mZGso","video":"_3R48Tn","image":"_4VOvcn","noBottomMargin":"WNgEq4"};